export const surveyConstants = {
    
    ADD_SURVEY: 'ADD_SURVEY',
    ADD_SUB_SURVEY: 'ADD_SUB_SURVEY',
    GET_SURVEY_DATA_SUCCESS: 'GET_SURVEY_DATA_SUCCESS',
    GET_SUB_SURVEY_DATA_SUCCESS: 'GET_SUB_SURVEY_DATA_SUCCESS',
    GET_COMPLETE_SURVEY_DATA_SUCCESS: 'GET_COMPLETE_SURVEY_DATA_SUCCESS',
    OPEN_ADD_NEW_SURVEY: 'OPEN_ADD_NEW_SURVEY',
    OPEN_ADD_NEW_SUB_SURVEY: 'OPEN_ADD_NEW_SUB_SURVEY',
    OPEN_EDIT_SURVEY: 'OPEN_EDIT_SURVEY',
    OPEN_EDIT_SUB_SURVEY: 'OPEN_EDIT_SUB_SURVEY',
    EDIT_SURVEY_SUCCESS: 'EDIT_SURVEY_SUCCESS',
    EDIT_SUB_SURVEY_SUCCESS: 'EDIT_SUB_SURVEY_SUCCESS',
    CLOSE_FORM_SURVEY: 'CLOSE_FORM_SURVEY',
    CLOSE_FORM_SUB_SURVEY: 'CLOSE_FORM_SUB_SURVEY',
    SET_FORM_PREVIEW_IMAGE: 'SET_FORM_PREVIEW_IMAGE',
    SET_FORM_PREVIEW_IMAGE_THANK: 'SET_FORM_PREVIEW_IMAGE_THANK',
    SURVEY_LIST:'SURVEY_LIST',
    DELETE_SUB_SURVEY_SUCCESS:'DELETE_SUB_SURVEY_SUCCESS',

    CLEAR_PAGE_STATE: 'CLEAR_PAGE_STATE',
    TABLE_RELOAD_SUCCESS: 'TABLE_RELOAD_SUCCESS',
    SHOW_TABLE_LOADER: 'SHOW_SURVEY_TABLE_LOADER',
    HIDE_TABLE_LOADER: 'HIDE_SURVEY_TABLE_LOADER',
    
}